/**
 * Utilidades para el manejo de errores de API
 */

/**
 * Mapea códigos de estado HTTP a mensajes amigables para el usuario
 * @param status Código de estado HTTP
 * @param feature Contexto del error ('contact' | 'careers')
 * @returns Mensaje amigable
 */
export const getFriendlyErrorMessage = (status: number, feature: 'contact' | 'careers' = 'contact'): string => {
  switch (status) {
    case 400:
      return feature === 'contact' 
        ? "Los datos enviados son inválidos. Por favor, verifica la información."
        : "La información de la postulación es inválida o faltan campos obligatorios.";
    case 401:
    case 403:
      return "No tienes permisos para realizar esta acción.";
    case 404:
      return feature === 'contact'
        ? "El servicio de contacto no está disponible. Por favor, intenta más tarde."
        : "El servicio de postulaciones no se encuentra disponible.";
    case 413:
      return "El archivo adjunto es demasiado grande. Por favor, sube un CV más liviano.";
    case 429:
      return "Has realizado demasiados intentos. Por favor, espera unos minutos.";
    case 500:
    case 502:
    case 503:
    case 504:
      return feature === 'contact'
        ? "Estamos experimentando problemas técnicos en nuestro servidor. Intenta de nuevo en un momento."
        : "Hubo un error en nuestro servidor al procesar tu CV. Por favor, intenta de nuevo.";
    default:
      return `Hubo un error inesperado (Código: ${status}).`;
  }
};

/**
 * Mensaje estándar para errores de red (cuando no hay respuesta del servidor)
 */
export const NETWORK_ERROR_MESSAGE = "No pudimos conectar con el servidor. Verifica tu conexión a internet e intenta nuevamente.";
